import {
  IColorFixedObjectStyleConfiguration,
  IBackgroundColorConfiguration,
  IBorderColorConfiguration,
  IObjectColorConfiguration,
  IEnableConfiguration,
} from "../../../../domain/configuration";
import { PaintStyle } from "../../../../domain/drawing";
import {
  IItem,
  IPaintable,
  instanceOfIPaintableOnEditing,
} from "../../../../domain/document/items";
import { AbstractObjectStyleReader } from "./AbstractObjectStyleReader";

export class ColorFixedObjectStyleReader extends AbstractObjectStyleReader<IItem & IPaintable> {
  constructor(private readonly _configuration: IColorFixedObjectStyleConfiguration) {
    super();
  }

  protected readSpecifiedPaintStyle(source: IItem & IPaintable): PaintStyle {
    return instanceOfIPaintableOnEditing(source)
      ? source.paintStyleOnEditing
      : source.paintStyle;
  }

  protected readBackgroundColorConfiguration(source: IItem & IPaintable): IBackgroundColorConfiguration {
    return this.readObjectStyleConfiguration(source);
  }

  protected readBorderColorConfiguration(source: IItem & IPaintable): IBorderColorConfiguration {
    return this.readObjectStyleConfiguration(source);
  }

  private readObjectStyleConfiguration(source: IItem & IPaintable): IObjectColorConfiguration {
    return this._configuration.default;
  }

  protected readForegroundDisplayConfiguration(): IEnableConfiguration {
    return null;
  }
}
